import { TbLoader2 } from "react-icons/tb";

export default function MegaButton({size=24, className, ...props}) {

  return (
    <button className={'py-2 px-4 rounded-lg ' + (className || '')} {...props}>
      {props.loading
        ? <TbLoader2 className="animate-spin-fast" size={size}/>
        : <>{props.labelText}</>
      }
    </button>
  )
}
